import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class NavbarService {
    navBarRef;
    onNavFolded = new EventEmitter<any>();

    static scrollToTheTop(selector: string) {
        const toolbar = document.querySelector(selector);
        if (toolbar) {
            toolbar.scrollIntoView({block: 'start'});
        }
    }

    constructor() {
    }

    setNavBar(ref) {
        this.navBarRef = ref;
    }

    getNavBar() {
        return this.navBarRef;
    }
}
